export const MANAGE_USER_API='/account/manage-user';

export const MANAGE_GROUP_API='/account/manage-group';

export const TRANSCRIPT_API='/account/generate-transcript';

export const READ_ALERTS_API='/account/read-alerts';

export const FETCH_ANALYTICS_API='/account/analytics-information';

export const PROCESS_THE_FILE='/account/file-process';

export const GET_CONVERSATION_BY_CAMPAIGN='/conversation';

export const GET_CAMPAIGN_LIST='/campaign';

export const CONVERSATION_BOOKMARKS_API='/fetch-bookmarked-conversations';

export const ALERTS_BY_CONVERSATION_API='/fetch-alerts-by-conversation-id';

export const ADMIN_SETTINGS='/account/admin-setting';